/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
// @ts-nocheck
import type { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { gql } from "graphql-tag";

/* tslint:disable */
/* eslint-disable */

const VariableName = " $1fcbcbff-3e78-462f-b45c-668a3e09bfd8";

const ScalarBrandingField = " $1fcbcbff-3e78-462f-b45c-668a3e09bfd9";

type CustomScalar<T> = { [ScalarBrandingField]: T };

class Variable<T, Name extends string> {
	private [VariableName]: Name;
	// @ts-ignore
	private _type?: T;

	// @ts-ignore
	constructor(
		name: Name,
		private readonly isRequired?: boolean,
	) {
		this[VariableName] = name;
	}
}

type ArrayInput<I> = [I] extends [$Atomic]
	? never
	: ReadonlyArray<VariabledInput<I>>;

type AllowedInlineScalars<S> = S extends string | number ? S : never;

export type UnwrapCustomScalars<T> =
	T extends CustomScalar<infer S>
		? S
		: T extends ReadonlyArray<infer I>
			? ReadonlyArray<UnwrapCustomScalars<I>>
			: T extends Record<string, any>
				? { [K in keyof T]: UnwrapCustomScalars<T[K]> }
				: T;

type VariableWithoutScalars<T, Str extends string> = Variable<
	UnwrapCustomScalars<T>,
	Str
>;

// the array wrapper prevents distributive conditional types
// https://www.typescriptlang.org/docs/handbook/2/conditional-types.html#distributive-conditional-types
type VariabledInput<T> = [T] extends [CustomScalar<infer S> | null | undefined]
	? // scalars only support variable input
			| Variable<S | null | undefined, any>
			| AllowedInlineScalars<S>
			| null
			| undefined
	: [T] extends [CustomScalar<infer S>]
		? Variable<S, any> | AllowedInlineScalars<S>
		: [T] extends [$Atomic]
			? Variable<T, any> | T
			: T extends ReadonlyArray<infer I>
				? VariableWithoutScalars<T, any> | T | ArrayInput<I>
				: T extends Record<string, any> | null | undefined
					?
							| VariableWithoutScalars<T | null | undefined, any>
							| null
							| undefined
							| { [K in keyof T]: VariabledInput<T[K]> }
							| T
					: T extends Record<string, any>
						?
								| VariableWithoutScalars<T, any>
								| { [K in keyof T]: VariabledInput<T[K]> }
								| T
						: never;

type UnionToIntersection<U> = (U extends any ? (k: U) => void : never) extends (
	k: infer I,
) => void
	? I
	: never;

/**
 * Creates a new query variable
 *
 * @param name The variable name
 */
export const $ = <Type, Name extends string>(
	name: Name,
): Variable<Type, Name> => {
	return new Variable(name);
};

/**
 * Creates a new query variable. A value will be required even if the input is optional
 *
 * @param name The variable name
 */
export const $$ = <Type, Name extends string>(
	name: Name,
): Variable<NonNullable<Type>, Name> => {
	return new Variable(name, true);
};

type SelectOptions = {
	argTypes?: { [key: string]: string };
	args?: { [key: string]: any };
	selection?: Selection<any>;
};

class $Field<Name extends string, Type, Vars = {}> {
	public kind: "field" = "field";
	public type!: Type;

	public vars!: Vars;
	public alias: string | null = null;

	constructor(
		public name: Name,
		public options: SelectOptions,
	) {}

	as<Rename extends string>(alias: Rename): $Field<Rename, Type, Vars> {
		const f = new $Field(this.name, this.options);
		f.alias = alias;
		return f as any;
	}
}

class $Base<Name extends string> {
	// @ts-ignore
	constructor(private $$name: Name) {}

	protected $_select<Key extends string>(
		name: Key,
		options: SelectOptions = {},
	): $Field<Key, any, any> {
		return new $Field(name, options);
	}
}

// @ts-ignore
class $Union<T, Name extends String> extends $Base<Name> {
	// @ts-ignore
	private $$type!: T;
	// @ts-ignore
	private $$name!: Name;

	constructor(
		private selectorClasses: { [K in keyof T]: { new (): T[K] } },
		$$name: Name,
	) {
		super($$name);
	}

	$on<Type extends keyof T, Sel extends Selection<T[Type]>>(
		alternative: Type,
		selectorFn: (selector: T[Type]) => [...Sel],
	): $UnionSelection<GetOutput<Sel>, GetVariables<Sel>> {
		const selection = selectorFn(new this.selectorClasses[alternative]());

		return new $UnionSelection(alternative as string, selection);
	}
}

// @ts-ignore
class $Interface<T, Name extends string> extends $Base<Name> {
	// @ts-ignore
	private $$type!: T;
	// @ts-ignore
	private $$name!: Name;

	constructor(
		private selectorClasses: { [K in keyof T]: { new (): T[K] } },
		$$name: Name,
	) {
		super($$name);
	}
	$on<Type extends keyof T, Sel extends Selection<T[Type]>>(
		alternative: Type,
		selectorFn: (selector: T[Type]) => [...Sel],
	): $UnionSelection<GetOutput<Sel>, GetVariables<Sel>> {
		const selection = selectorFn(new this.selectorClasses[alternative]());

		return new $UnionSelection(alternative as string, selection);
	}
}

class $UnionSelection<T, Vars> {
	public kind: "union" = "union";
	// @ts-ignore
	private vars!: Vars;
	constructor(
		public alternativeName: string,
		public alternativeSelection: Selection<T>,
	) {}
}

type Selection<_any> = ReadonlyArray<
	$Field<any, any, any> | $UnionSelection<any, any>
>;

type NeverNever<T> = [T] extends [never] ? {} : T;

type Simplify<T> = { [K in keyof T]: T[K] } & {};

type LeafType<T> = T extends CustomScalar<infer S> ? S : T;

export type GetOutput<X extends Selection<any>> = Simplify<
	UnionToIntersection<
		{
			[I in keyof X]: X[I] extends $Field<infer Name, infer Type, any>
				? { [K in Name]: LeafType<Type> }
				: never;
		}[keyof X & number]
	> &
		NeverNever<
			{
				[I in keyof X]: X[I] extends $UnionSelection<infer Type, any>
					? LeafType<Type>
					: never;
			}[keyof X & number]
		>
>;

type PossiblyOptionalVar<VName extends string, VType> = null extends VType
	? { [key in VName]?: VType }
	: { [key in VName]: VType };

type ExtractInputVariables<Inputs> =
	Inputs extends Variable<infer VType, infer VName>
		? PossiblyOptionalVar<VName, VType>
		: // Avoid generating an index signature for possibly undefined or null inputs.
			// The compiler incorrectly infers null or undefined, and we must force access the Inputs
			// type to convince the compiler its "never", while still retaining {} as the result
			// for null and undefined cases
			// Works around issue 79
			Inputs extends null | undefined
			? { [K in keyof Inputs]: Inputs[K] }
			: Inputs extends $Atomic
				? {}
				: Inputs extends any[] | readonly any[]
					? UnionToIntersection<
							{
								[K in keyof Inputs]: ExtractInputVariables<Inputs[K]>;
							}[keyof Inputs & number]
						>
					: UnionToIntersection<
							{
								[K in keyof Inputs]: ExtractInputVariables<Inputs[K]>;
							}[keyof Inputs]
						>;

export type GetVariables<
	Sel extends Selection<any>,
	ExtraVars = {},
> = UnionToIntersection<
	{
		[I in keyof Sel]: Sel[I] extends $Field<any, any, infer Vars>
			? Vars
			: Sel[I] extends $UnionSelection<any, infer Vars>
				? Vars
				: never;
	}[keyof Sel & number]
> &
	ExtractInputVariables<ExtraVars>;

type ArgVarType = {
	type: string;
	isRequired: boolean;
	array: {
		isRequired: boolean;
	} | null;
};

const arrRegex = /\[(.*?)\]/;

/**
 * Converts graphql string type to `ArgVarType`
 * @param input
 * @returns
 */
function getArgVarType(input: string): ArgVarType {
	const array = input.includes("[")
		? {
				isRequired: input.endsWith("!"),
			}
		: null;

	const type = array ? arrRegex.exec(input)![1]! : input;
	const isRequired = type.endsWith("!");

	return {
		array,
		isRequired: isRequired,
		type: type.replace("!", ""),
	};
}

function fieldToQuery(prefix: string, field: $Field<any, any, any>) {
	const variables = new Map<
		string,
		{ variable: Variable<any, any>; type: ArgVarType }
	>();

	function stringifyArgs(
		args: any,
		argTypes: { [key: string]: string },
		argVarType?: ArgVarType,
	): string {
		switch (typeof args) {
			case "string":
				const cleanType = argVarType!.type;
				if ($Enums.has(cleanType!)) return args;
				else return JSON.stringify(args);
			case "number":
			case "boolean":
				return JSON.stringify(args);
			default:
				if (args == null) return "null";
				if (VariableName in (args as any)) {
					if (!argVarType)
						throw new globalThis.Error(
							"Cannot use variabe as sole unnamed field argument",
						);
					const variable = args as Variable<any, any>;
					const argVarName = variable[VariableName];
					variables.set(argVarName, { type: argVarType, variable: variable });
					return "$" + argVarName;
				}
				if (Array.isArray(args))
					return (
						"[" +
						args
							.map((arg) => stringifyArgs(arg, argTypes, argVarType))
							.join(",") +
						"]"
					);
				const wrapped = (content: string) =>
					argVarType ? "{" + content + "}" : content;
				return wrapped(
					Array.from(Object.entries(args))
						.map(([key, val]) => {
							let argTypeForKey = argTypes[key];
							if (!argTypeForKey) {
								throw new globalThis.Error(
									`Argument type for ${key} not found`,
								);
							}
							const cleanType = argTypeForKey
								.replace("[", "")
								.replace("]", "")
								.replace(/!/g, "");
							return (
								key +
								":" +
								stringifyArgs(
									val,
									$InputTypes[cleanType]!,
									getArgVarType(argTypeForKey),
								)
							);
						})
						.join(","),
				);
		}
	}

	function extractTextAndVars(
		field: $Field<any, any, any> | $UnionSelection<any, any>,
	) {
		if (field.kind === "field") {
			let retVal = field.name;
			if (field.alias) retVal = field.alias + ":" + retVal;
			const args = field.options.args,
				argTypes = field.options.argTypes;
			if (args && Object.keys(args).length > 0) {
				retVal += "(" + stringifyArgs(args, argTypes!) + ")";
			}
			let sel = field.options.selection;
			if (sel) {
				retVal += "{";
				for (let subField of sel) {
					retVal += extractTextAndVars(subField);
				}
				retVal += "}";
			}
			return retVal + " ";
		} else if (field.kind === "union") {
			let retVal = "... on " + field.alternativeName + " {";
			for (let subField of field.alternativeSelection) {
				retVal += extractTextAndVars(subField);
			}
			retVal += "}";

			return retVal + " ";
		} else {
			throw new globalThis.Error("Uknown field kind");
		}
	}

	const queryRaw = extractTextAndVars(field)!;

	const queryBody = queryRaw.substring(queryRaw.indexOf("{"));

	const varList = Array.from(variables.entries());
	let ret = prefix;
	if (varList.length) {
		ret +=
			"(" +
			varList
				.map(([name, { type: kind, variable }]) => {
					let type = kind.array ? "[" : "";
					type += kind.type;
					if (kind.isRequired) type += "!";
					if (kind.array) type += kind.array.isRequired ? "]!" : "]";

					if (!type.endsWith("!") && (variable as any).isRequired === true) {
						type += "!";
					}

					return "$" + name + ":" + type;
				})
				.join(",") +
			")";
	}
	ret += queryBody;

	return ret;
}

export type OutputTypeOf<T> =
	T extends $Interface<infer Subtypes, any>
		? { [K in keyof Subtypes]: OutputTypeOf<Subtypes[K]> }[keyof Subtypes]
		: T extends $Union<infer Subtypes, any>
			? { [K in keyof Subtypes]: OutputTypeOf<Subtypes[K]> }[keyof Subtypes]
			: T extends $Base<any>
				? { [K in keyof T]?: OutputTypeOf<T[K]> }
				: [T] extends [$Field<any, infer FieldType, any>]
					? FieldType
					: [T] extends [(selFn: (arg: infer Inner) => any) => any]
						? OutputTypeOf<Inner>
						: [T] extends [(args: any, selFn: (arg: infer Inner) => any) => any]
							? OutputTypeOf<Inner>
							: never;

export type QueryOutputType<T extends TypedDocumentNode<any>> =
	T extends TypedDocumentNode<infer Out> ? Out : never;

export type QueryInputType<T extends TypedDocumentNode<any>> =
	T extends TypedDocumentNode<any, infer In> ? In : never;

export function fragment<T, Sel extends Selection<T>>(
	GQLType: { new (): T },
	selectFn: (selector: T) => [...Sel],
) {
	return selectFn(new GQLType());
}

type LastOf<T> =
	UnionToIntersection<T extends any ? () => T : never> extends () => infer R
		? R
		: never;

// TS4.0+
type Push<T extends any[], V> = [...T, V];

// TS4.1+
type TuplifyUnion<
	T,
	L = LastOf<T>,
	N = [T] extends [never] ? true : false,
> = true extends N ? [] : Push<TuplifyUnion<Exclude<T, L>>, L>;

type AllFieldProperties<I> = {
	[K in keyof I]: I[K] extends $Field<infer Name, infer Type, any>
		? $Field<Name, Type, any>
		: never;
};

type ValueOf<T> = T[keyof T];

export type AllFields<T> = TuplifyUnion<ValueOf<AllFieldProperties<T>>>;

export function all<I extends $Base<any>>(instance: I) {
	const prototype = Object.getPrototypeOf(instance);
	const allFields = Object.getOwnPropertyNames(prototype)
		.map((k) => prototype[k])
		.filter((o) => o?.kind === "field")
		.map((o) => o?.name) as (keyof typeof instance)[];
	return allFields.map(
		(fieldName) => instance?.[fieldName],
	) as any as AllFields<I>;
}

// We use a dummy conditional type that involves GenericType to defer the compiler's inference of
// any possible variables nested in this type. This addresses a problem where variables are
// inferred with type unknown
// @ts-ignore
type ExactArgNames<GenericType, Constraint> = GenericType extends never
	? never
	: [Constraint] extends [$Atomic | CustomScalar<any>]
		? GenericType
		: Constraint extends ReadonlyArray<infer InnerConstraint>
			? GenericType extends ReadonlyArray<infer Inner>
				? ReadonlyArray<ExactArgNames<Inner, InnerConstraint>>
				: GenericType
			: GenericType & {
					[Key in keyof GenericType]: Key extends keyof Constraint
						? ExactArgNames<GenericType[Key], Constraint[Key]>
						: never;
				};

export type NameOf<T> =
	T extends $Interface<any, infer Name>
		? Name
		: T extends $Union<any, infer Name>
			? Name
			: T extends $Base<infer Name>
				? Name
				: never;
type $Atomic =
	| CardMedia
	| CardScheme
	| Channel
	| ConnectionType
	| ContactMethod
	| CustomerRole
	| EcommerceContactStatus
	| EcommerceStatus
	| EcommerceTransactionStatus
	| EcommerceType
	| OnboardingStatus
	| PosMethod
	| PosMode
	| SiteType
	| Source
	| SourceFilter
	| SplitPaymentType
	| ThreeDSOutcome
	| TransactionIssuer
	| TransactionStatus
	| TransactionType
	| ZellerPosFavouriteType
	| number
	| string
	| boolean
	| null
	| undefined;

let $Enums = new Set<string>([
	"CardMedia",
	"CardScheme",
	"Channel",
	"ConnectionType",
	"ContactMethod",
	"CustomerRole",
	"EcommerceContactStatus",
	"EcommerceStatus",
	"EcommerceTransactionStatus",
	"EcommerceType",
	"OnboardingStatus",
	"PosMethod",
	"PosMode",
	"SiteType",
	"Source",
	"SourceFilter",
	"SplitPaymentType",
	"ThreeDSOutcome",
	"TransactionIssuer",
	"TransactionStatus",
	"TransactionType",
	"ZellerPosFavouriteType",
]);

export class AppSyncDomain extends $Base<"AppSyncDomain"> {
	constructor() {
		super("AppSyncDomain");
	}

	get apiKey(): $Field<"apiKey", string | null> {
		return this.$_select("apiKey") as any;
	}

	get apiUrl(): $Field<"apiUrl", string | null> {
		return this.$_select("apiUrl") as any;
	}

	get region(): $Field<"region", string | null> {
		return this.$_select("region") as any;
	}

	get wssUrl(): $Field<"wssUrl", string | null> {
		return this.$_select("wssUrl") as any;
	}
}

export class CustomerEntityMapping extends $Base<"CustomerEntityMapping"> {
	constructor() {
		super("CustomerEntityMapping");
	}

	get defaultEntityUuid(): $Field<"defaultEntityUuid", string> {
		return this.$_select("defaultEntityUuid") as any;
	}

	entityRelations<Sel extends Selection<CustomerEntityRelation>>(
		selectorFn: (s: CustomerEntityRelation) => [...Sel],
	): $Field<
		"entityRelations",
		Array<GetOutput<Sel>> | null,
		GetVariables<Sel>
	> {
		const options = {
			selection: selectorFn(new CustomerEntityRelation()),
		};
		return this.$_select("entityRelations", options as any) as any;
	}
}

export class CustomerEntityRelation extends $Base<"CustomerEntityRelation"> {
	constructor() {
		super("CustomerEntityRelation");
	}

	entity<Sel extends Selection<EntitySummary>>(
		selectorFn: (s: EntitySummary) => [...Sel],
	): $Field<"entity", GetOutput<Sel>, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new EntitySummary()),
		};
		return this.$_select("entity", options as any) as any;
	}

	get entityUuid(): $Field<"entityUuid", string> {
		return this.$_select("entityUuid") as any;
	}

	get role(): $Field<"role", CustomerRole> {
		return this.$_select("role") as any;
	}
}

export class DeviceScreensaver extends $Base<"DeviceScreensaver"> {
	constructor() {
		super("DeviceScreensaver");
	}

	get primaryColour(): $Field<"primaryColour", string> {
		return this.$_select("primaryColour") as any;
	}

	get primaryLogoUrl(): $Field<"primaryLogoUrl", string> {
		return this.$_select("primaryLogoUrl") as any;
	}
}

export class DeviceSettings extends $Base<"DeviceSettings"> {
	constructor() {
		super("DeviceSettings");
	}

	entity<Sel extends Selection<EntityDeviceSettings>>(
		selectorFn: (s: EntityDeviceSettings) => [...Sel],
	): $Field<"entity", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new EntityDeviceSettings()),
		};
		return this.$_select("entity", options as any) as any;
	}

	get entityUuid(): $Field<"entityUuid", string> {
		return this.$_select("entityUuid") as any;
	}

	get id(): $Field<"id", string> {
		return this.$_select("id") as any;
	}

	get model(): $Field<"model", string | null> {
		return this.$_select("model") as any;
	}

	get name(): $Field<"name", string | null> {
		return this.$_select("name") as any;
	}

	posPairConfiguration<Sel extends Selection<PosPairConfiguration>>(
		selectorFn: (s: PosPairConfiguration) => [...Sel],
	): $Field<"posPairConfiguration", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new PosPairConfiguration()),
		};
		return this.$_select("posPairConfiguration", options as any) as any;
	}

	posSettings<Sel extends Selection<PosSettings>>(
		selectorFn: (s: PosSettings) => [...Sel],
	): $Field<"posSettings", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new PosSettings()),
		};
		return this.$_select("posSettings", options as any) as any;
	}

	get serial(): $Field<"serial", string | null> {
		return this.$_select("serial") as any;
	}

	site<Sel extends Selection<SiteDeviceSettings>>(
		selectorFn: (s: SiteDeviceSettings) => [...Sel],
	): $Field<"site", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new SiteDeviceSettings()),
		};
		return this.$_select("site", options as any) as any;
	}

	surchargesTaxes<Sel extends Selection<SurchargesTaxesSettings>>(
		selectorFn: (s: SurchargesTaxesSettings) => [...Sel],
	): $Field<"surchargesTaxes", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new SurchargesTaxesSettings()),
		};
		return this.$_select("surchargesTaxes", options as any) as any;
	}
}

export class DeviceUuidResponse extends $Base<"DeviceUuidResponse"> {
	constructor() {
		super("DeviceUuidResponse");
	}

	get id(): $Field<"id", string> {
		return this.$_select("id") as any;
	}

	get model(): $Field<"model", string> {
		return this.$_select("model") as any;
	}

	get serial(): $Field<"serial", string> {
		return this.$_select("serial") as any;
	}
}

export class Ecommerce extends $Base<"Ecommerce"> {
	constructor() {
		super("Ecommerce");
	}

	get amount(): $Field<"amount", number> {
		return this.$_select("amount") as any;
	}

	get amountDue(): $Field<"amountDue", number> {
		return this.$_select("amountDue") as any;
	}

	get contactDetails(): $Field<"contactDetails", string | null> {
		return this.$_select("contactDetails") as any;
	}

	get contactError(): $Field<"contactError", string | null> {
		return this.$_select("contactError") as any;
	}

	get contactStatus(): $Field<"contactStatus", EcommerceContactStatus | null> {
		return this.$_select("contactStatus") as any;
	}

	get contactType(): $Field<"contactType", ContactMethod | null> {
		return this.$_select("contactType") as any;
	}

	get createdTimestamp(): $Field<"createdTimestamp", AWSDateTime | null> {
		return this.$_select("createdTimestamp") as any;
	}

	get currency(): $Field<"currency", string> {
		return this.$_select("currency") as any;
	}

	get customerUuid(): $Field<"customerUuid", string | null> {
		return this.$_select("customerUuid") as any;
	}

	get entityUuid(): $Field<"entityUuid", string> {
		return this.$_select("entityUuid") as any;
	}

	get expiry(): $Field<"expiry", AWSDateTime | null> {
		return this.$_select("expiry") as any;
	}

	get id(): $Field<"id", string> {
		return this.$_select("id") as any;
	}

	get lastViewedAt(): $Field<"lastViewedAt", AWSDateTime | null> {
		return this.$_select("lastViewedAt") as any;
	}

	get notes(): $Field<"notes", string | null> {
		return this.$_select("notes") as any;
	}

	get paidAmount(): $Field<"paidAmount", number> {
		return this.$_select("paidAmount") as any;
	}

	get paymentLink(): $Field<"paymentLink", string | null> {
		return this.$_select("paymentLink") as any;
	}

	get posReference(): $Field<"posReference", string | null> {
		return this.$_select("posReference") as any;
	}

	get reference(): $Field<"reference", string> {
		return this.$_select("reference") as any;
	}

	get siteName(): $Field<"siteName", string> {
		return this.$_select("siteName") as any;
	}

	get siteUuid(): $Field<"siteUuid", string> {
		return this.$_select("siteUuid") as any;
	}

	get status(): $Field<"status", EcommerceStatus> {
		return this.$_select("status") as any;
	}

	get surcharge(): $Field<"surcharge", number | null> {
		return this.$_select("surcharge") as any;
	}

	taxAmounts<Sel extends Selection<TaxAmount>>(
		selectorFn: (s: TaxAmount) => [...Sel],
	): $Field<
		"taxAmounts",
		Array<GetOutput<Sel> | null> | null,
		GetVariables<Sel>
	> {
		const options = {
			selection: selectorFn(new TaxAmount()),
		};
		return this.$_select("taxAmounts", options as any) as any;
	}

	get timestamp(): $Field<"timestamp", AWSDateTime> {
		return this.$_select("timestamp") as any;
	}

	get timestampSent(): $Field<"timestampSent", AWSDateTime | null> {
		return this.$_select("timestampSent") as any;
	}

	transaction<Sel extends Selection<Transaction>>(
		selectorFn: (s: Transaction) => [...Sel],
	): $Field<"transaction", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new Transaction()),
		};
		return this.$_select("transaction", options as any) as any;
	}

	transactionRecords<Sel extends Selection<EcommerceTransactionRecord>>(
		selectorFn: (s: EcommerceTransactionRecord) => [...Sel],
	): $Field<
		"transactionRecords",
		Array<GetOutput<Sel> | null> | null,
		GetVariables<Sel>
	> {
		const options = {
			selection: selectorFn(new EcommerceTransactionRecord()),
		};
		return this.$_select("transactionRecords", options as any) as any;
	}

	get transactionUuid(): $Field<"transactionUuid", string | null> {
		return this.$_select("transactionUuid") as any;
	}

	get type(): $Field<"type", EcommerceType> {
		return this.$_select("type") as any;
	}
}

export class EcommerceTransactionRecord extends $Base<"EcommerceTransactionRecord"> {
	constructor() {
		super("EcommerceTransactionRecord");
	}

	details<Sel extends Selection<Transaction>>(
		selectorFn: (s: Transaction) => [...Sel],
	): $Field<"details", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new Transaction()),
		};
		return this.$_select("details", options as any) as any;
	}

	get status(): $Field<"status", EcommerceTransactionStatus> {
		return this.$_select("status") as any;
	}

	get transactionUuid(): $Field<"transactionUuid", string> {
		return this.$_select("transactionUuid") as any;
	}

	get updatedAt(): $Field<"updatedAt", AWSDateTime> {
		return this.$_select("updatedAt") as any;
	}
}

export class Entity extends $Base<"Entity"> {
	constructor() {
		super("Entity");
	}

	get id(): $Field<"id", string> {
		return this.$_select("id") as any;
	}

	get name(): $Field<"name", string | null> {
		return this.$_select("name") as any;
	}

	get onboardingStatus(): $Field<"onboardingStatus", OnboardingStatus | null> {
		return this.$_select("onboardingStatus") as any;
	}

	get tradingName(): $Field<"tradingName", string | null> {
		return this.$_select("tradingName") as any;
	}
}

export class EntityDeviceSettings extends $Base<"EntityDeviceSettings"> {
	constructor() {
		super("EntityDeviceSettings");
	}

	get canAcquire(): $Field<"canAcquire", boolean | null> {
		return this.$_select("canAcquire") as any;
	}

	get canAcquireAmexCnp(): $Field<"canAcquireAmexCnp", boolean | null> {
		return this.$_select("canAcquireAmexCnp") as any;
	}

	get canRefund(): $Field<"canRefund", boolean | null> {
		return this.$_select("canRefund") as any;
	}

	get currency(): $Field<"currency", string | null> {
		return this.$_select("currency") as any;
	}

	get domicile(): $Field<"domicile", string | null> {
		return this.$_select("domicile") as any;
	}
}

export class EntitySummary extends $Base<"EntitySummary"> {
	constructor() {
		super("EntitySummary");
	}

	get id(): $Field<"id", string> {
		return this.$_select("id") as any;
	}

	get name(): $Field<"name", string | null> {
		return this.$_select("name") as any;
	}

	get onboardingStatus(): $Field<"onboardingStatus", OnboardingStatus | null> {
		return this.$_select("onboardingStatus") as any;
	}

	get tradingName(): $Field<"tradingName", string | null> {
		return this.$_select("tradingName") as any;
	}
}

export class FeesSurchargeFixedIntl extends $Base<"FeesSurchargeFixedIntl"> {
	constructor() {
		super("FeesSurchargeFixedIntl");
	}

	get feeFixed(): $Field<"feeFixed", number | null> {
		return this.$_select("feeFixed") as any;
	}

	get feeFixedIntl(): $Field<"feeFixedIntl", number | null> {
		return this.$_select("feeFixedIntl") as any;
	}

	get feePercent(): $Field<"feePercent", number | null> {
		return this.$_select("feePercent") as any;
	}

	get feePercentIntl(): $Field<"feePercentIntl", number | null> {
		return this.$_select("feePercentIntl") as any;
	}

	get surchargeEnabled(): $Field<"surchargeEnabled", boolean | null> {
		return this.$_select("surchargeEnabled") as any;
	}

	get surchargeFullFees(): $Field<"surchargeFullFees", boolean | null> {
		return this.$_select("surchargeFullFees") as any;
	}

	get surchargePercent(): $Field<"surchargePercent", number | null> {
		return this.$_select("surchargePercent") as any;
	}
}

export class HlSettings extends $Base<"HlSettings"> {
	constructor() {
		super("HlSettings");
	}

	get billingSummary(): $Field<"billingSummary", boolean> {
		return this.$_select("billingSummary") as any;
	}
}

export class ImposConfiguration extends $Base<"ImposConfiguration"> {
	constructor() {
		super("ImposConfiguration");
	}

	get clientApiKey(): $Field<"clientApiKey", string | null> {
		return this.$_select("clientApiKey") as any;
	}

	get hostIp(): $Field<"hostIp", string | null> {
		return this.$_select("hostIp") as any;
	}

	venues<Sel extends Selection<PosVenue>>(
		selectorFn: (s: PosVenue) => [...Sel],
	): $Field<"venues", Array<GetOutput<Sel>> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new PosVenue()),
		};
		return this.$_select("venues", options as any) as any;
	}
}

export class ImposSettings extends $Base<"ImposSettings"> {
	constructor() {
		super("ImposSettings");
	}

	get billingSummary(): $Field<"billingSummary", boolean> {
		return this.$_select("billingSummary") as any;
	}
}

export class Location extends $Base<"Location"> {
	constructor() {
		super("Location");
	}

	get accuracy(): $Field<"accuracy", number | null> {
		return this.$_select("accuracy") as any;
	}

	get location(): $Field<"location", string | null> {
		return this.$_select("location") as any;
	}

	get timestampLocal(): $Field<"timestampLocal", AWSDateTime | null> {
		return this.$_select("timestampLocal") as any;
	}
}

export class Mutation extends $Base<"Mutation"> {
	constructor() {
		super("Mutation");
	}

	assignDeviceToEntity<
		Args extends VariabledInput<{
			deviceUuid: string;
			entityUuid: string;
			name: string;
		}>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
				entityUuid: string;
				name: string;
			}
		>,
	): $Field<"assignDeviceToEntity", boolean | null, GetVariables<[], Args>> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
				entityUuid: "ID!",
				name: "String!",
			},
			args,
		};
		return this.$_select("assignDeviceToEntity", options as any) as any;
	}

	configureImpos<
		Args extends VariabledInput<{
			config: ImposConfigurationInput;
			deviceUuid: string;
		}>,
		Sel extends Selection<ImposConfiguration>,
	>(
		args: ExactArgNames<
			Args,
			{
				config: ImposConfigurationInput;
				deviceUuid: string;
			}
		>,
		selectorFn: (s: ImposConfiguration) => [...Sel],
	): $Field<"configureImpos", GetOutput<Sel>, GetVariables<Sel, Args>> {
		const options = {
			argTypes: {
				config: "ImposConfigurationInput!",
				deviceUuid: "ID!",
			},
			args,

			selection: selectorFn(new ImposConfiguration()),
		};
		return this.$_select("configureImpos", options as any) as any;
	}

	createAndSendPayByLink<
		Args extends VariabledInput<{
			deviceUuid: string;
			entityUuid: string;
			input: CreateAndSendPayByLinkInput;
		}>,
		Sel extends Selection<Ecommerce>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
				entityUuid: string;
				input: CreateAndSendPayByLinkInput;
			}
		>,
		selectorFn: (s: Ecommerce) => [...Sel],
	): $Field<"createAndSendPayByLink", GetOutput<Sel>, GetVariables<Sel, Args>> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
				entityUuid: "String!",
				input: "CreateAndSendPayByLinkInput!",
			},
			args,

			selection: selectorFn(new Ecommerce()),
		};
		return this.$_select("createAndSendPayByLink", options as any) as any;
	}

	getDeviceUuid<
		Args extends VariabledInput<{
			input: DeviceUuidInput;
		}>,
		Sel extends Selection<DeviceUuidResponse>,
	>(
		args: ExactArgNames<
			Args,
			{
				input: DeviceUuidInput;
			}
		>,
		selectorFn: (s: DeviceUuidResponse) => [...Sel],
	): $Field<"getDeviceUuid", GetOutput<Sel>, GetVariables<Sel, Args>> {
		const options = {
			argTypes: {
				input: "DeviceUuidInput!",
			},
			args,

			selection: selectorFn(new DeviceUuidResponse()),
		};
		return this.$_select("getDeviceUuid", options as any) as any;
	}

	pairDevices<
		Args extends VariabledInput<{
			deviceUuid: string;
			input: Readonly<Array<DevicePairInput>>;
		}>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
				input: Readonly<Array<DevicePairInput>>;
			}
		>,
	): $Field<"pairDevices", boolean, GetVariables<[], Args>> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
				input: "[DevicePairInput!]!",
			},
			args,
		};
		return this.$_select("pairDevices", options as any) as any;
	}

	publishVirtualTerminalRecordUpdateEvent<
		Args extends VariabledInput<{
			input?: SubscriptionEcommerceRecordInput | null;
		}>,
		Sel extends Selection<Ecommerce>,
	>(
		args: ExactArgNames<
			Args,
			{
				input?: SubscriptionEcommerceRecordInput | null;
			}
		>,
		selectorFn: (s: Ecommerce) => [...Sel],
	): $Field<
		"publishVirtualTerminalRecordUpdateEvent",
		GetOutput<Sel> | null,
		GetVariables<Sel, Args>
	>;
	publishVirtualTerminalRecordUpdateEvent<Sel extends Selection<Ecommerce>>(
		selectorFn: (s: Ecommerce) => [...Sel],
	): $Field<
		"publishVirtualTerminalRecordUpdateEvent",
		GetOutput<Sel> | null,
		GetVariables<Sel>
	>;
	publishVirtualTerminalRecordUpdateEvent(arg1: any, arg2?: any) {
		const { args, selectorFn } = !arg2
			? { args: {}, selectorFn: arg1 }
			: { args: arg1, selectorFn: arg2 };

		const options = {
			argTypes: {
				input: "SubscriptionEcommerceRecordInput",
			},
			args,

			selection: selectorFn(new Ecommerce()),
		};
		return this.$_select(
			"publishVirtualTerminalRecordUpdateEvent",
			options as any,
		) as any;
	}

	removeDeviceFromEntity<
		Args extends VariabledInput<{
			deviceUuid: string;
			entityUuid: string;
		}>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
				entityUuid: string;
			}
		>,
	): $Field<"removeDeviceFromEntity", boolean | null, GetVariables<[], Args>> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
				entityUuid: "ID!",
			},
			args,
		};
		return this.$_select("removeDeviceFromEntity", options as any) as any;
	}

	sendPayByLink<
		Args extends VariabledInput<{
			deviceUuid: string;
			entityUuid: string;
			input: SendPayByLinkInput;
		}>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
				entityUuid: string;
				input: SendPayByLinkInput;
			}
		>,
	): $Field<"sendPayByLink", boolean, GetVariables<[], Args>> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
				entityUuid: "String!",
				input: "SendPayByLinkInput!",
			},
			args,
		};
		return this.$_select("sendPayByLink", options as any) as any;
	}

	unpairDevices<
		Args extends VariabledInput<{
			deviceUuid: string;
			input: Readonly<Array<DeviceUnpairInput>>;
		}>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
				input: Readonly<Array<DeviceUnpairInput>>;
			}
		>,
	): $Field<"unpairDevices", boolean, GetVariables<[], Args>> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
				input: "[DeviceUnpairInput!]!",
			},
			args,
		};
		return this.$_select("unpairDevices", options as any) as any;
	}

	updateDeviceInformation<
		Args extends VariabledInput<{
			input: DeviceStatusInput;
		}>,
	>(
		args: ExactArgNames<
			Args,
			{
				input: DeviceStatusInput;
			}
		>,
	): $Field<"updateDeviceInformation", boolean, GetVariables<[], Args>> {
		const options = {
			argTypes: {
				input: "DeviceStatusInput!",
			},
			args,
		};
		return this.$_select("updateDeviceInformation", options as any) as any;
	}

	voidPayByLink<
		Args extends VariabledInput<{
			deviceUuid: string;
			entityUuid?: string | null;
			id: string;
		}>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
				entityUuid?: string | null;
				id: string;
			}
		>,
	): $Field<"voidPayByLink", boolean, GetVariables<[], Args>> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
				entityUuid: "ID",
				id: "ID!",
			},
			args,
		};
		return this.$_select("voidPayByLink", options as any) as any;
	}
}

export class OraclePosSettings extends $Base<"OraclePosSettings"> {
	constructor() {
		super("OraclePosSettings");
	}

	get workstationId(): $Field<"workstationId", string> {
		return this.$_select("workstationId") as any;
	}
}

export class OtherTaxSettings extends $Base<"OtherTaxSettings"> {
	constructor() {
		super("OtherTaxSettings");
	}

	get name(): $Field<"name", string | null> {
		return this.$_select("name") as any;
	}

	get percent(): $Field<"percent", number | null> {
		return this.$_select("percent") as any;
	}
}

export class PairedDevice extends $Base<"PairedDevice"> {
	constructor() {
		super("PairedDevice");
	}

	get deviceUuid(): $Field<"deviceUuid", string> {
		return this.$_select("deviceUuid") as any;
	}

	get locationNames(): $Field<"locationNames", Readonly<Array<string>> | null> {
		return this.$_select("locationNames") as any;
	}

	get pairedDeviceId(): $Field<"pairedDeviceId", string | null> {
		return this.$_select("pairedDeviceId") as any;
	}

	get provider(): $Field<"provider", ConnectionType> {
		return this.$_select("provider") as any;
	}

	get venueName(): $Field<"venueName", string | null> {
		return this.$_select("venueName") as any;
	}
}

export class PairedDevicesConnection extends $Base<"PairedDevicesConnection"> {
	constructor() {
		super("PairedDevicesConnection");
	}

	items<Sel extends Selection<PairedDevice>>(
		selectorFn: (s: PairedDevice) => [...Sel],
	): $Field<"items", Array<GetOutput<Sel>>, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new PairedDevice()),
		};
		return this.$_select("items", options as any) as any;
	}

	get nextToken(): $Field<"nextToken", string | null> {
		return this.$_select("nextToken") as any;
	}
}

export class PosLocation extends $Base<"PosLocation"> {
	constructor() {
		super("PosLocation");
	}

	get id(): $Field<"id", string> {
		return this.$_select("id") as any;
	}

	get name(): $Field<"name", string> {
		return this.$_select("name") as any;
	}

	get number(): $Field<"number", string | null> {
		return this.$_select("number") as any;
	}
}

export class PosPairConfiguration extends $Base<"PosPairConfiguration"> {
	constructor() {
		super("PosPairConfiguration");
	}

	get deviceType(): $Field<"deviceType", string | null> {
		return this.$_select("deviceType") as any;
	}

	get deviceUuid(): $Field<"deviceUuid", string | null> {
		return this.$_select("deviceUuid") as any;
	}

	devices<Sel extends Selection<DeviceSettings>>(
		selectorFn: (s: DeviceSettings) => [...Sel],
	): $Field<"devices", Array<GetOutput<Sel>> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new DeviceSettings()),
		};
		return this.$_select("devices", options as any) as any;
	}

	get id(): $Field<"id", string> {
		return this.$_select("id") as any;
	}

	get locationId(): $Field<"locationId", string | null> {
		return this.$_select("locationId") as any;
	}

	get pairedDeviceId(): $Field<"pairedDeviceId", string | null> {
		return this.$_select("pairedDeviceId") as any;
	}

	get siteUuid(): $Field<"siteUuid", string | null> {
		return this.$_select("siteUuid") as any;
	}

	get stationId(): $Field<"stationId", string | null> {
		return this.$_select("stationId") as any;
	}

	get venueId(): $Field<"venueId", string | null> {
		return this.$_select("venueId") as any;
	}
}

export class PosSettings extends $Base<"PosSettings"> {
	constructor() {
		super("PosSettings");
	}

	get active(): $Field<"active", Source | null> {
		return this.$_select("active") as any;
	}

	get clientAddress(): $Field<"clientAddress", string | null> {
		return this.$_select("clientAddress") as any;
	}

	get connectionMethod(): $Field<"connectionMethod", PosMethod | null> {
		return this.$_select("connectionMethod") as any;
	}

	get exitRequiresPin(): $Field<"exitRequiresPin", boolean | null> {
		return this.$_select("exitRequiresPin") as any;
	}

	hlSettings<Sel extends Selection<HlSettings>>(
		selectorFn: (s: HlSettings) => [...Sel],
	): $Field<"hlSettings", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new HlSettings()),
		};
		return this.$_select("hlSettings", options as any) as any;
	}

	imposSettings<Sel extends Selection<ImposSettings>>(
		selectorFn: (s: ImposSettings) => [...Sel],
	): $Field<"imposSettings", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new ImposSettings()),
		};
		return this.$_select("imposSettings", options as any) as any;
	}

	get ipAddress(): $Field<"ipAddress", string | null> {
		return this.$_select("ipAddress") as any;
	}

	get mode(): $Field<"mode", PosMode | null> {
		return this.$_select("mode") as any;
	}

	oracleSettings<Sel extends Selection<OraclePosSettings>>(
		selectorFn: (s: OraclePosSettings) => [...Sel],
	): $Field<"oracleSettings", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new OraclePosSettings()),
		};
		return this.$_select("oracleSettings", options as any) as any;
	}

	get port(): $Field<"port", number | null> {
		return this.$_select("port") as any;
	}

	get posReceipt(): $Field<"posReceipt", boolean | null> {
		return this.$_select("posReceipt") as any;
	}

	get posRegisterName(): $Field<"posRegisterName", string | null> {
		return this.$_select("posRegisterName") as any;
	}

	get posSoftwareName(): $Field<"posSoftwareName", string | null> {
		return this.$_select("posSoftwareName") as any;
	}

	posVenue<Sel extends Selection<PosVenue>>(
		selectorFn: (s: PosVenue) => [...Sel],
	): $Field<"posVenue", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new PosVenue()),
		};
		return this.$_select("posVenue", options as any) as any;
	}

	tevalisSettings<Sel extends Selection<TevalisPosSettings>>(
		selectorFn: (s: TevalisPosSettings) => [...Sel],
	): $Field<"tevalisSettings", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new TevalisPosSettings()),
		};
		return this.$_select("tevalisSettings", options as any) as any;
	}

	zellerPosSettings<Sel extends Selection<ZellerPosSettings>>(
		selectorFn: (s: ZellerPosSettings) => [...Sel],
	): $Field<"zellerPosSettings", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new ZellerPosSettings()),
		};
		return this.$_select("zellerPosSettings", options as any) as any;
	}
}

export class PosVenue extends $Base<"PosVenue"> {
	constructor() {
		super("PosVenue");
	}

	get id(): $Field<"id", string | null> {
		return this.$_select("id") as any;
	}

	locations<Sel extends Selection<PosLocation>>(
		selectorFn: (s: PosLocation) => [...Sel],
	): $Field<"locations", Array<GetOutput<Sel>> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new PosLocation()),
		};
		return this.$_select("locations", options as any) as any;
	}

	get name(): $Field<"name", string> {
		return this.$_select("name") as any;
	}
}

export class Query extends $Base<"Query"> {
	constructor() {
		super("Query");
	}

	getCustomerEntityMapping<Sel extends Selection<CustomerEntityMapping>>(
		selectorFn: (s: CustomerEntityMapping) => [...Sel],
	): $Field<"getCustomerEntityMapping", GetOutput<Sel>, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new CustomerEntityMapping()),
		};
		return this.$_select("getCustomerEntityMapping", options as any) as any;
	}

	getDeviceSettings<
		Args extends VariabledInput<{
			deviceUuid: string;
		}>,
		Sel extends Selection<DeviceSettings>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
			}
		>,
		selectorFn: (s: DeviceSettings) => [...Sel],
	): $Field<"getDeviceSettings", GetOutput<Sel>, GetVariables<Sel, Args>> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
			},
			args,

			selection: selectorFn(new DeviceSettings()),
		};
		return this.$_select("getDeviceSettings", options as any) as any;
	}

	getImposConfiguration<
		Args extends VariabledInput<{
			deviceUuid: string;
		}>,
		Sel extends Selection<ImposConfiguration>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
			}
		>,
		selectorFn: (s: ImposConfiguration) => [...Sel],
	): $Field<
		"getImposConfiguration",
		GetOutput<Sel> | null,
		GetVariables<Sel, Args>
	> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
			},
			args,

			selection: selectorFn(new ImposConfiguration()),
		};
		return this.$_select("getImposConfiguration", options as any) as any;
	}

	getPairedDevices<
		Args extends VariabledInput<{
			deviceUuid: string;
			filter?: PairedDevicesFilter | null;
			limit: number;
			nextToken?: string | null;
		}>,
		Sel extends Selection<PairedDevicesConnection>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
				filter?: PairedDevicesFilter | null;
				limit: number;
				nextToken?: string | null;
			}
		>,
		selectorFn: (s: PairedDevicesConnection) => [...Sel],
	): $Field<"getPairedDevices", GetOutput<Sel>, GetVariables<Sel, Args>> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
				filter: "PairedDevicesFilter",
				limit: "Int!",
				nextToken: "String",
			},
			args,

			selection: selectorFn(new PairedDevicesConnection()),
		};
		return this.$_select("getPairedDevices", options as any) as any;
	}

	getPosPairConfiguration<
		Args extends VariabledInput<{
			deviceUuid: string;
			provider: ConnectionType;
		}>,
		Sel extends Selection<PosPairConfiguration>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
				provider: ConnectionType;
			}
		>,
		selectorFn: (s: PosPairConfiguration) => [...Sel],
	): $Field<
		"getPosPairConfiguration",
		Array<GetOutput<Sel>>,
		GetVariables<Sel, Args>
	> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
				provider: "ConnectionType!",
			},
			args,

			selection: selectorFn(new PosPairConfiguration()),
		};
		return this.$_select("getPosPairConfiguration", options as any) as any;
	}

	getSites<
		Args extends VariabledInput<{
			deviceUuid: string;
			filter?: SiteFilterInput | null;
			limit: number;
			nextToken?: SiteNextTokenInput | null;
		}>,
		Sel extends Selection<SiteConnection>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
				filter?: SiteFilterInput | null;
				limit: number;
				nextToken?: SiteNextTokenInput | null;
			}
		>,
		selectorFn: (s: SiteConnection) => [...Sel],
	): $Field<"getSites", GetOutput<Sel>, GetVariables<Sel, Args>> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
				filter: "SiteFilterInput",
				limit: "Int!",
				nextToken: "SiteNextTokenInput",
			},
			args,

			selection: selectorFn(new SiteConnection()),
		};
		return this.$_select("getSites", options as any) as any;
	}

	getSubscriptionUrl<Sel extends Selection<AppSyncDomain>>(
		selectorFn: (s: AppSyncDomain) => [...Sel],
	): $Field<"getSubscriptionUrl", GetOutput<Sel>, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new AppSyncDomain()),
		};
		return this.$_select("getSubscriptionUrl", options as any) as any;
	}

	getTransaction<
		Args extends VariabledInput<{
			deviceUuid: string;
			transactionUuid: string;
		}>,
		Sel extends Selection<Transaction>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
				transactionUuid: string;
			}
		>,
		selectorFn: (s: Transaction) => [...Sel],
	): $Field<"getTransaction", GetOutput<Sel>, GetVariables<Sel, Args>> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
				transactionUuid: "ID!",
			},
			args,

			selection: selectorFn(new Transaction()),
		};
		return this.$_select("getTransaction", options as any) as any;
	}

	getTransactions<
		Args extends VariabledInput<{
			deviceUuid: string;
			filter?: TransactionFilterInput | null;
			limit: number;
			nextToken?: TransactionNextTokenInput | null;
		}>,
		Sel extends Selection<TransactionConnection>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
				filter?: TransactionFilterInput | null;
				limit: number;
				nextToken?: TransactionNextTokenInput | null;
			}
		>,
		selectorFn: (s: TransactionConnection) => [...Sel],
	): $Field<"getTransactions", GetOutput<Sel>, GetVariables<Sel, Args>> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
				filter: "TransactionFilterInput",
				limit: "Int!",
				nextToken: "TransactionNextTokenInput",
			},
			args,

			selection: selectorFn(new TransactionConnection()),
		};
		return this.$_select("getTransactions", options as any) as any;
	}

	getVirtualTerminalRecord<
		Args extends VariabledInput<{
			deviceUuid: string;
			entityUuid: string;
			id: string;
		}>,
		Sel extends Selection<Ecommerce>,
	>(
		args: ExactArgNames<
			Args,
			{
				deviceUuid: string;
				entityUuid: string;
				id: string;
			}
		>,
		selectorFn: (s: Ecommerce) => [...Sel],
	): $Field<
		"getVirtualTerminalRecord",
		GetOutput<Sel>,
		GetVariables<Sel, Args>
	> {
		const options = {
			argTypes: {
				deviceUuid: "ID!",
				entityUuid: "ID!",
				id: "String!",
			},
			args,

			selection: selectorFn(new Ecommerce()),
		};
		return this.$_select("getVirtualTerminalRecord", options as any) as any;
	}
}

export class Site extends $Base<"Site"> {
	constructor() {
		super("Site");
	}

	devices<
		Args extends VariabledInput<{
			models?: Readonly<Array<string>> | null;
		}>,
		Sel extends Selection<DeviceSettings>,
	>(
		args: ExactArgNames<
			Args,
			{
				models?: Readonly<Array<string>> | null;
			}
		>,
		selectorFn: (s: DeviceSettings) => [...Sel],
	): $Field<"devices", Array<GetOutput<Sel>> | null, GetVariables<Sel, Args>>;
	devices<Sel extends Selection<DeviceSettings>>(
		selectorFn: (s: DeviceSettings) => [...Sel],
	): $Field<"devices", Array<GetOutput<Sel>> | null, GetVariables<Sel>>;
	devices(arg1: any, arg2?: any) {
		const { args, selectorFn } = !arg2
			? { args: {}, selectorFn: arg1 }
			: { args: arg1, selectorFn: arg2 };

		const options = {
			argTypes: {
				models: "[String!]",
			},
			args,

			selection: selectorFn(new DeviceSettings()),
		};
		return this.$_select("devices", options as any) as any;
	}

	get id(): $Field<"id", string> {
		return this.$_select("id") as any;
	}

	get name(): $Field<"name", string> {
		return this.$_select("name") as any;
	}

	surchargesTaxes<Sel extends Selection<SurchargesTaxesSettings>>(
		selectorFn: (s: SurchargesTaxesSettings) => [...Sel],
	): $Field<"surchargesTaxes", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new SurchargesTaxesSettings()),
		};
		return this.$_select("surchargesTaxes", options as any) as any;
	}
}

export class SiteConnection extends $Base<"SiteConnection"> {
	constructor() {
		super("SiteConnection");
	}

	nextToken<Sel extends Selection<SiteNextToken>>(
		selectorFn: (s: SiteNextToken) => [...Sel],
	): $Field<"nextToken", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new SiteNextToken()),
		};
		return this.$_select("nextToken", options as any) as any;
	}

	sites<Sel extends Selection<Site>>(
		selectorFn: (s: Site) => [...Sel],
	): $Field<"sites", Array<GetOutput<Sel> | null>, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new Site()),
		};
		return this.$_select("sites", options as any) as any;
	}
}

export class SiteDeviceSettings extends $Base<"SiteDeviceSettings"> {
	constructor() {
		super("SiteDeviceSettings");
	}

	get name(): $Field<"name", string> {
		return this.$_select("name") as any;
	}

	screensaver<Sel extends Selection<DeviceScreensaver>>(
		selectorFn: (s: DeviceScreensaver) => [...Sel],
	): $Field<"screensaver", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new DeviceScreensaver()),
		};
		return this.$_select("screensaver", options as any) as any;
	}

	get siteUuid(): $Field<"siteUuid", string> {
		return this.$_select("siteUuid") as any;
	}

	get type(): $Field<"type", SiteType | null> {
		return this.$_select("type") as any;
	}
}

export class SiteNextToken extends $Base<"SiteNextToken"> {
	constructor() {
		super("SiteNextToken");
	}

	get siteNameSortKey(): $Field<"siteNameSortKey", string> {
		return this.$_select("siteNameSortKey") as any;
	}

	get type(): $Field<"type", string> {
		return this.$_select("type") as any;
	}
}

export class SplitPayment extends $Base<"SplitPayment"> {
	constructor() {
		super("SplitPayment");
	}

	get id(): $Field<"id", string> {
		return this.$_select("id") as any;
	}

	get portions(): $Field<"portions", number | null> {
		return this.$_select("portions") as any;
	}

	get targetAmount(): $Field<"targetAmount", number> {
		return this.$_select("targetAmount") as any;
	}

	transactions<Sel extends Selection<Transaction>>(
		selectorFn: (s: Transaction) => [...Sel],
	): $Field<"transactions", Array<GetOutput<Sel>>, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new Transaction()),
		};
		return this.$_select("transactions", options as any) as any;
	}

	get type(): $Field<"type", SplitPaymentType> {
		return this.$_select("type") as any;
	}
}

export class Subscription extends $Base<"Subscription"> {
	constructor() {
		super("Subscription");
	}

	onVirtualTerminalRecordUpdate<
		Args extends VariabledInput<{
			entityUuid: string;
			id: string;
		}>,
		Sel extends Selection<Ecommerce>,
	>(
		args: ExactArgNames<
			Args,
			{
				entityUuid: string;
				id: string;
			}
		>,
		selectorFn: (s: Ecommerce) => [...Sel],
	): $Field<
		"onVirtualTerminalRecordUpdate",
		GetOutput<Sel> | null,
		GetVariables<Sel, Args>
	> {
		const options = {
			argTypes: {
				entityUuid: "ID!",
				id: "ID!",
			},
			args,

			selection: selectorFn(new Ecommerce()),
		};
		return this.$_select(
			"onVirtualTerminalRecordUpdate",
			options as any,
		) as any;
	}
}

export class SurchargesTaxesSettings extends $Base<"SurchargesTaxesSettings"> {
	constructor() {
		super("SurchargesTaxesSettings");
	}

	get feeFixedCnp(): $Field<"feeFixedCnp", number | null> {
		return this.$_select("feeFixedCnp") as any;
	}

	get feePercent(): $Field<"feePercent", number | null> {
		return this.$_select("feePercent") as any;
	}

	get feePercentCnp(): $Field<"feePercentCnp", number | null> {
		return this.$_select("feePercentCnp") as any;
	}

	get feePercentMoto(): $Field<"feePercentMoto", number | null> {
		return this.$_select("feePercentMoto") as any;
	}

	feesSurchargeCp<Sel extends Selection<FeesSurchargeFixedIntl>>(
		selectorFn: (s: FeesSurchargeFixedIntl) => [...Sel],
	): $Field<"feesSurchargeCp", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new FeesSurchargeFixedIntl()),
		};
		return this.$_select("feesSurchargeCp", options as any) as any;
	}

	feesSurchargeCpoc<Sel extends Selection<FeesSurchargeFixedIntl>>(
		selectorFn: (s: FeesSurchargeFixedIntl) => [...Sel],
	): $Field<"feesSurchargeCpoc", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new FeesSurchargeFixedIntl()),
		};
		return this.$_select("feesSurchargeCpoc", options as any) as any;
	}

	feesSurchargeMoto<Sel extends Selection<FeesSurchargeFixedIntl>>(
		selectorFn: (s: FeesSurchargeFixedIntl) => [...Sel],
	): $Field<"feesSurchargeMoto", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new FeesSurchargeFixedIntl()),
		};
		return this.$_select("feesSurchargeMoto", options as any) as any;
	}

	feesSurchargePbl<Sel extends Selection<FeesSurchargeFixedIntl>>(
		selectorFn: (s: FeesSurchargeFixedIntl) => [...Sel],
	): $Field<"feesSurchargePbl", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new FeesSurchargeFixedIntl()),
		};
		return this.$_select("feesSurchargePbl", options as any) as any;
	}

	feesSurchargeVt<Sel extends Selection<FeesSurchargeFixedIntl>>(
		selectorFn: (s: FeesSurchargeFixedIntl) => [...Sel],
	): $Field<"feesSurchargeVt", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new FeesSurchargeFixedIntl()),
		};
		return this.$_select("feesSurchargeVt", options as any) as any;
	}

	feesSurchargeXinv<Sel extends Selection<FeesSurchargeFixedIntl>>(
		selectorFn: (s: FeesSurchargeFixedIntl) => [...Sel],
	): $Field<"feesSurchargeXinv", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new FeesSurchargeFixedIntl()),
		};
		return this.$_select("feesSurchargeXinv", options as any) as any;
	}

	feesSurchargeZinv<Sel extends Selection<FeesSurchargeFixedIntl>>(
		selectorFn: (s: FeesSurchargeFixedIntl) => [...Sel],
	): $Field<"feesSurchargeZinv", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new FeesSurchargeFixedIntl()),
		};
		return this.$_select("feesSurchargeZinv", options as any) as any;
	}

	get gstEnabled(): $Field<"gstEnabled", boolean | null> {
		return this.$_select("gstEnabled") as any;
	}

	get gstPercent(): $Field<"gstPercent", number | null> {
		return this.$_select("gstPercent") as any;
	}

	get surchargeAllowed(): $Field<"surchargeAllowed", boolean | null> {
		return this.$_select("surchargeAllowed") as any;
	}

	get surchargeEnabled(): $Field<"surchargeEnabled", boolean | null> {
		return this.$_select("surchargeEnabled") as any;
	}

	get surchargeEnabledCnp(): $Field<"surchargeEnabledCnp", boolean | null> {
		return this.$_select("surchargeEnabledCnp") as any;
	}

	get surchargeEnabledMoto(): $Field<"surchargeEnabledMoto", boolean | null> {
		return this.$_select("surchargeEnabledMoto") as any;
	}

	get surchargeFullFees(): $Field<"surchargeFullFees", boolean | null> {
		return this.$_select("surchargeFullFees") as any;
	}

	get surchargeFullFeesCnp(): $Field<"surchargeFullFeesCnp", boolean | null> {
		return this.$_select("surchargeFullFeesCnp") as any;
	}

	get surchargeFullFeesMoto(): $Field<"surchargeFullFeesMoto", boolean | null> {
		return this.$_select("surchargeFullFeesMoto") as any;
	}

	get surchargePercent(): $Field<"surchargePercent", number | null> {
		return this.$_select("surchargePercent") as any;
	}

	get surchargePercentCnp(): $Field<"surchargePercentCnp", number | null> {
		return this.$_select("surchargePercentCnp") as any;
	}

	get surchargePercentMoto(): $Field<"surchargePercentMoto", number | null> {
		return this.$_select("surchargePercentMoto") as any;
	}

	taxes<Sel extends Selection<OtherTaxSettings>>(
		selectorFn: (s: OtherTaxSettings) => [...Sel],
	): $Field<"taxes", Array<GetOutput<Sel> | null> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new OtherTaxSettings()),
		};
		return this.$_select("taxes", options as any) as any;
	}
}

export class TaxAmount extends $Base<"TaxAmount"> {
	constructor() {
		super("TaxAmount");
	}

	get amount(): $Field<"amount", number> {
		return this.$_select("amount") as any;
	}

	get name(): $Field<"name", string> {
		return this.$_select("name") as any;
	}
}

export class TevalisPosSettings extends $Base<"TevalisPosSettings"> {
	constructor() {
		super("TevalisPosSettings");
	}

	get billingSummary(): $Field<"billingSummary", boolean> {
		return this.$_select("billingSummary") as any;
	}
}

export class Transaction extends $Base<"Transaction"> {
	constructor() {
		super("Transaction");
	}

	get adjustAmount(): $Field<"adjustAmount", number | null> {
		return this.$_select("adjustAmount") as any;
	}

	get amount(): $Field<"amount", number> {
		return this.$_select("amount") as any;
	}

	get approvalCode(): $Field<"approvalCode", string | null> {
		return this.$_select("approvalCode") as any;
	}

	get bin(): $Field<"bin", string | null> {
		return this.$_select("bin") as any;
	}

	get caid(): $Field<"caid", string | null> {
		return this.$_select("caid") as any;
	}

	get cardMedia(): $Field<"cardMedia", CardMedia | null> {
		return this.$_select("cardMedia") as any;
	}

	get cardholderEmail(): $Field<"cardholderEmail", string | null> {
		return this.$_select("cardholderEmail") as any;
	}

	get cardholderName(): $Field<"cardholderName", string | null> {
		return this.$_select("cardholderName") as any;
	}

	get cardholderPhone(): $Field<"cardholderPhone", string | null> {
		return this.$_select("cardholderPhone") as any;
	}

	get cardholderUuid(): $Field<"cardholderUuid", string | null> {
		return this.$_select("cardholderUuid") as any;
	}

	get catid(): $Field<"catid", string | null> {
		return this.$_select("catid") as any;
	}

	get channel(): $Field<"channel", Channel | null> {
		return this.$_select("channel") as any;
	}

	get currency(): $Field<"currency", string | null> {
		return this.$_select("currency") as any;
	}

	get customerName(): $Field<"customerName", string | null> {
		return this.$_select("customerName") as any;
	}

	get customerUuid(): $Field<"customerUuid", string | null> {
		return this.$_select("customerUuid") as any;
	}

	get depositDate(): $Field<"depositDate", AWSDateTime | null> {
		return this.$_select("depositDate") as any;
	}

	get depositUuid(): $Field<"depositUuid", string | null> {
		return this.$_select("depositUuid") as any;
	}

	get deposited(): $Field<"deposited", boolean | null> {
		return this.$_select("deposited") as any;
	}

	get deviceModel(): $Field<"deviceModel", string | null> {
		return this.$_select("deviceModel") as any;
	}

	get deviceName(): $Field<"deviceName", string | null> {
		return this.$_select("deviceName") as any;
	}

	get deviceUuid(): $Field<"deviceUuid", string | null> {
		return this.$_select("deviceUuid") as any;
	}

	get emvAid(): $Field<"emvAid", string | null> {
		return this.$_select("emvAid") as any;
	}

	get emvAppName(): $Field<"emvAppName", string | null> {
		return this.$_select("emvAppName") as any;
	}

	get emvTagsPrint(): $Field<"emvTagsPrint", string | null> {
		return this.$_select("emvTagsPrint") as any;
	}

	get entityUuid(): $Field<"entityUuid", string> {
		return this.$_select("entityUuid") as any;
	}

	get externalReference(): $Field<"externalReference", string | null> {
		return this.$_select("externalReference") as any;
	}

	get feeAmount(): $Field<"feeAmount", number | null> {
		return this.$_select("feeAmount") as any;
	}

	get feeCharged(): $Field<"feeCharged", boolean | null> {
		return this.$_select("feeCharged") as any;
	}

	get id(): $Field<"id", string> {
		return this.$_select("id") as any;
	}

	images<Sel extends Selection<TransactionImageDownloadUrls>>(
		selectorFn: (s: TransactionImageDownloadUrls) => [...Sel],
	): $Field<"images", Array<GetOutput<Sel>> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new TransactionImageDownloadUrls()),
		};
		return this.$_select("images", options as any) as any;
	}

	get isoProcessingCode(): $Field<"isoProcessingCode", string | null> {
		return this.$_select("isoProcessingCode") as any;
	}

	get issuer(): $Field<"issuer", TransactionIssuer | null> {
		return this.$_select("issuer") as any;
	}

	location<Sel extends Selection<Location>>(
		selectorFn: (s: Location) => [...Sel],
	): $Field<"location", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new Location()),
		};
		return this.$_select("location", options as any) as any;
	}

	get maskedPan(): $Field<"maskedPan", string | null> {
		return this.$_select("maskedPan") as any;
	}

	get notes(): $Field<"notes", string | null> {
		return this.$_select("notes") as any;
	}

	get posName(): $Field<"posName", string | null> {
		return this.$_select("posName") as any;
	}

	get receiptLink(): $Field<"receiptLink", string | null> {
		return this.$_select("receiptLink") as any;
	}

	get reference(): $Field<"reference", string | null> {
		return this.$_select("reference") as any;
	}

	refundTransactions<Sel extends Selection<Transaction>>(
		selectorFn: (s: Transaction) => [...Sel],
	): $Field<
		"refundTransactions",
		Array<GetOutput<Sel>> | null,
		GetVariables<Sel>
	> {
		const options = {
			selection: selectorFn(new Transaction()),
		};
		return this.$_select("refundTransactions", options as any) as any;
	}

	get refunded(): $Field<"refunded", boolean | null> {
		return this.$_select("refunded") as any;
	}

	get refundedAmount(): $Field<"refundedAmount", number | null> {
		return this.$_select("refundedAmount") as any;
	}

	refundedTransaction<Sel extends Selection<Transaction>>(
		selectorFn: (s: Transaction) => [...Sel],
	): $Field<"refundedTransaction", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new Transaction()),
		};
		return this.$_select("refundedTransaction", options as any) as any;
	}

	get refundedTransactionUuid(): $Field<
		"refundedTransactionUuid",
		string | null
	> {
		return this.$_select("refundedTransactionUuid") as any;
	}

	get responseCode(): $Field<"responseCode", string | null> {
		return this.$_select("responseCode") as any;
	}

	get responseDescription(): $Field<"responseDescription", string | null> {
		return this.$_select("responseDescription") as any;
	}

	get reversed(): $Field<"reversed", boolean | null> {
		return this.$_select("reversed") as any;
	}

	get review(): $Field<"review", boolean | null> {
		return this.$_select("review") as any;
	}

	get saleAmount(): $Field<"saleAmount", number> {
		return this.$_select("saleAmount") as any;
	}

	get scheme(): $Field<"scheme", CardScheme> {
		return this.$_select("scheme") as any;
	}

	get siteName(): $Field<"siteName", string | null> {
		return this.$_select("siteName") as any;
	}

	get siteUuid(): $Field<"siteUuid", string> {
		return this.$_select("siteUuid") as any;
	}

	get source(): $Field<"source", Source | null> {
		return this.$_select("source") as any;
	}

	get sourceFilter(): $Field<"sourceFilter", SourceFilter | null> {
		return this.$_select("sourceFilter") as any;
	}

	splitPayment<Sel extends Selection<SplitPayment>>(
		selectorFn: (s: SplitPayment) => [...Sel],
	): $Field<"splitPayment", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new SplitPayment()),
		};
		return this.$_select("splitPayment", options as any) as any;
	}

	get splitPaymentUuid(): $Field<"splitPaymentUuid", string | null> {
		return this.$_select("splitPaymentUuid") as any;
	}

	get stan(): $Field<"stan", string | null> {
		return this.$_select("stan") as any;
	}

	get status(): $Field<"status", TransactionStatus> {
		return this.$_select("status") as any;
	}

	get surchargeAmount(): $Field<"surchargeAmount", number> {
		return this.$_select("surchargeAmount") as any;
	}

	taxAmounts<Sel extends Selection<TaxAmount>>(
		selectorFn: (s: TaxAmount) => [...Sel],
	): $Field<"taxAmounts", Array<GetOutput<Sel>> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new TaxAmount()),
		};
		return this.$_select("taxAmounts", options as any) as any;
	}

	get threeDSOutcome(): $Field<"threeDSOutcome", ThreeDSOutcome | null> {
		return this.$_select("threeDSOutcome") as any;
	}

	get timestamp(): $Field<"timestamp", AWSDateTime> {
		return this.$_select("timestamp") as any;
	}

	get tipAmount(): $Field<"tipAmount", number> {
		return this.$_select("tipAmount") as any;
	}

	get type(): $Field<"type", TransactionType> {
		return this.$_select("type") as any;
	}
}

export class TransactionConnection extends $Base<"TransactionConnection"> {
	constructor() {
		super("TransactionConnection");
	}

	nextToken<Sel extends Selection<TransactionNextToken>>(
		selectorFn: (s: TransactionNextToken) => [...Sel],
	): $Field<"nextToken", GetOutput<Sel> | null, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new TransactionNextToken()),
		};
		return this.$_select("nextToken", options as any) as any;
	}

	transactions<Sel extends Selection<Transaction>>(
		selectorFn: (s: Transaction) => [...Sel],
	): $Field<"transactions", Array<GetOutput<Sel>>, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new Transaction()),
		};
		return this.$_select("transactions", options as any) as any;
	}
}

export class TransactionImageDownloadUrls extends $Base<"TransactionImageDownloadUrls"> {
	constructor() {
		super("TransactionImageDownloadUrls");
	}

	get downloadUrl(): $Field<"downloadUrl", string> {
		return this.$_select("downloadUrl") as any;
	}

	get expireDate(): $Field<"expireDate", AWSDateTime> {
		return this.$_select("expireDate") as any;
	}

	get fileName(): $Field<"fileName", string> {
		return this.$_select("fileName") as any;
	}

	get fileUuid(): $Field<"fileUuid", string> {
		return this.$_select("fileUuid") as any;
	}
}

export class TransactionNextToken extends $Base<"TransactionNextToken"> {
	constructor() {
		super("TransactionNextToken");
	}

	get entityUuid(): $Field<"entityUuid", string> {
		return this.$_select("entityUuid") as any;
	}

	get id(): $Field<"id", string> {
		return this.$_select("id") as any;
	}

	get type(): $Field<"type", string> {
		return this.$_select("type") as any;
	}
}

export class ZellerPosFavourites extends $Base<"ZellerPosFavourites"> {
	constructor() {
		super("ZellerPosFavourites");
	}

	get id(): $Field<"id", string> {
		return this.$_select("id") as any;
	}

	get type(): $Field<"type", ZellerPosFavouriteType> {
		return this.$_select("type") as any;
	}
}

export class ZellerPosSettings extends $Base<"ZellerPosSettings"> {
	constructor() {
		super("ZellerPosSettings");
	}

	favourites<Sel extends Selection<ZellerPosFavourites>>(
		selectorFn: (s: ZellerPosFavourites) => [...Sel],
	): $Field<"favourites", Array<GetOutput<Sel>>, GetVariables<Sel>> {
		const options = {
			selection: selectorFn(new ZellerPosFavourites()),
		};
		return this.$_select("favourites", options as any) as any;
	}
}

export enum CardMedia {
	CNP = "CNP",

	CNP_APPLE_PAY = "CNP_APPLE_PAY",

	CNP_GOOGLE_PAY = "CNP_GOOGLE_PAY",

	ICC = "ICC",

	MANUAL = "MANUAL",

	MSR = "MSR",

	NFC = "NFC",

	PICC = "PICC",
}

export enum CardScheme {
	AMEX = "AMEX",

	CUP = "CUP",

	DINERS = "DINERS",

	DISCOVER = "DISCOVER",

	EFTPOS = "EFTPOS",

	JCB = "JCB",

	MC = "MC",

	OTHER = "OTHER",

	VISA = "VISA",
}

export enum Channel {
	DASHBOARD = "DASHBOARD",

	MOBILE_ANDROID = "MOBILE_ANDROID",

	MOBILE_IOS = "MOBILE_IOS",

	PAY_MYZELLER = "PAY_MYZELLER",

	TERMINAL = "TERMINAL",

	ZELLER_ADMIN = "ZELLER_ADMIN",
}

export enum ConnectionType {
	HL_POS = "HL_POS",

	IMPOS = "IMPOS",

	ORACLE_POS = "ORACLE_POS",

	SDK = "SDK",
}

export enum ContactMethod {
	EMAIL = "EMAIL",

	SMS = "SMS",
}

export enum CustomerRole {
	ADMIN = "ADMIN",

	MANAGER = "MANAGER",
}

export enum EcommerceContactStatus {
	FAILED = "FAILED",

	SENT = "SENT",
}

export enum EcommerceStatus {
	CANCELLED = "CANCELLED",

	EXPIRED = "EXPIRED",

	NOT_PAID = "NOT_PAID",

	PAID = "PAID",
}

export enum EcommerceTransactionStatus {
	APPROVED = "APPROVED",

	DECLINED = "DECLINED",

	PROCESSING = "PROCESSING",
}

export enum EcommerceType {
	SDK_PAY_BY_LINK = "SDK_PAY_BY_LINK",
}

export enum OnboardingStatus {
	ALT_BOS_ESTABLISHED = "ALT_BOS_ESTABLISHED",

	BEN_ESTABLISHED = "BEN_ESTABLISHED",

	BOS_ESTABLISHED = "BOS_ESTABLISHED",

	BUSINESS_REG_COLLECTED = "BUSINESS_REG_COLLECTED",

	BV_COMPLETE = "BV_COMPLETE",

	BV_ERROR = "BV_ERROR",

	CHAIR_ESTABLISHED = "CHAIR_ESTABLISHED",

	DIRECTORS_ESTABLISHED = "DIRECTORS_ESTABLISHED",

	DOC_UPLOADED = "DOC_UPLOADED",

	ENTITY_ADDRESS1 = "ENTITY_ADDRESS1",

	ENTITY_ADDRESS2 = "ENTITY_ADDRESS2",

	ENTITY_CATEGORY = "ENTITY_CATEGORY",

	ENTITY_ESTABLISHED = "ENTITY_ESTABLISHED",

	ENTITY_REVENUE = "ENTITY_REVENUE",

	FINALISING_ONBOARDING = "FINALISING_ONBOARDING",

	FINALISING_ONBOARDING_IN_PROGRESS = "FINALISING_ONBOARDING_IN_PROGRESS",

	GOVERNMENT_ROLE_ESTABLISHED = "GOVERNMENT_ROLE_ESTABLISHED",

	IDV_COMPLETE = "IDV_COMPLETE",

	IDV_REQUIRED = "IDV_REQUIRED",

	MORE_INFO_COLLECTED = "MORE_INFO_COLLECTED",

	NONE = "NONE",

	ONBOARDED = "ONBOARDED",

	PARTNERS_ESTABLISHED = "PARTNERS_ESTABLISHED",

	PHONE_COMPLETE = "PHONE_COMPLETE",

	RC_ABANDONED = "RC_ABANDONED",

	RC_DEPLATFORMED = "RC_DEPLATFORMED",

	RC_ONBOARDED = "RC_ONBOARDED",

	RC_REJECTED = "RC_REJECTED",

	RC_REVIEW = "RC_REVIEW",

	REVIEW = "REVIEW",

	SECRETARY_ESTABLISHED = "SECRETARY_ESTABLISHED",

	SETTLORS_ESTABLISHED = "SETTLORS_ESTABLISHED",

	TRADING_NAME_ESTABLISHED = "TRADING_NAME_ESTABLISHED",

	TREASURE_ESTABLISHED = "TREASURE_ESTABLISHED",

	TRUSTEES_ESTABLISHED = "TRUSTEES_ESTABLISHED",
}

export enum PosMethod {
	CLOUD = "CLOUD",

	CLOUD_ASYNC = "CLOUD_ASYNC",

	LAN = "LAN",

	POS_CONNECTOR = "POS_CONNECTOR",
}

export enum PosMode {
	INTEGRATED = "INTEGRATED",

	INTERFACED = "INTERFACED",

	PAY_AT_TABLE = "PAY_AT_TABLE",
}

export enum SiteType {
	CNP_XERO_INVOICE = "CNP_XERO_INVOICE",

	CNP_ZELLER_INVOICE = "CNP_ZELLER_INVOICE",

	FIXED = "FIXED",

	MOBILE = "MOBILE",
}

export enum Source {
	HL_POS = "HL_POS",

	IMPOS = "IMPOS",

	LINKLY = "LINKLY",

	ORACLE_POS = "ORACLE_POS",

	PAY_BY_LINK = "PAY_BY_LINK",

	QUICKPOS = "QUICKPOS",

	SDK = "SDK",

	SDK_PAY_BY_LINK = "SDK_PAY_BY_LINK",

	STANDALONE = "STANDALONE",

	TEVALIS_POS = "TEVALIS_POS",

	VIRTUAL_TERMINAL = "VIRTUAL_TERMINAL",

	XERO_INVOICE = "XERO_INVOICE",

	ZELLER_INVOICE = "ZELLER_INVOICE",

	ZELLER_POS = "ZELLER_POS",
}

export enum SourceFilter {
	DASHBOARD = "DASHBOARD",

	INVOICE = "INVOICE",

	POINT_OF_SALE = "POINT_OF_SALE",

	TERMINAL = "TERMINAL",

	ZELLER_ADMIN = "ZELLER_ADMIN",

	ZELLER_APP = "ZELLER_APP",
}

export enum SplitPaymentType {
	AMOUNT = "AMOUNT",

	ITEMS = "ITEMS",

	PORTION = "PORTION",
}

export enum ThreeDSOutcome {
	FAILED = "FAILED",

	PASSED = "PASSED",
}

export enum TransactionIssuer {
	AFTERPAY = "AFTERPAY",
}

export enum TransactionStatus {
	APPROVED = "APPROVED",

	DECLINED = "DECLINED",

	DELETED = "DELETED",

	PROCESSING = "PROCESSING",
}

export enum TransactionType {
	ACCOUNTVERIFY = "ACCOUNTVERIFY",

	ADJUSTMENT = "ADJUSTMENT",

	CASHOUT = "CASHOUT",

	DEPOSIT = "DEPOSIT",

	PREAUTH = "PREAUTH",

	PURCHASE = "PURCHASE",

	PURCHASEADVICE = "PURCHASEADVICE",

	REFUND = "REFUND",

	REFUNDADVICE = "REFUNDADVICE",

	REVERSAL = "REVERSAL",
}

export enum ZellerPosFavouriteType {
	CATEGORY = "CATEGORY",

	ITEM = "ITEM",
}

export type BoolFilterInput = {
	eq?: boolean | null;
	ne?: boolean | null;
};

export type CreateAndSendPayByLinkInput = {
	amount: number;
	contact: PayByContactInput;
	reference: string;
};

export type DevicePairInput = {
	override: boolean;
	pairedDeviceUuid: string;
};

export type DeviceStatusInput = {
	androidBuild?: string | null;
	androidDevice?: string | null;
	androidKernel?: string | null;
	androidModel?: string | null;
	androidOs?: string | null;
	appUptimeInSeconds?: number | null;
	batteryLevelPercent?: number | null;
	connectionType?: number | null;
	customerId?: string | null;
	customerName?: string | null;
	density?: string | null;
	densityDpi?: string | null;
	deviceUptimeInSeconds?: number | null;
	emvL1Version?: string | null;
	emvL2Version?: string | null;
	firmwareVersion?: string | null;
	flashAvail?: string | null;
	flashTotal?: string | null;
	hardwareVersion?: string | null;
	heightPixels?: string | null;
	id: string;
	kernel?: string | null;
	ksn?: string | null;
	model?: string | null;
	numAids?: number | null;
	numCapk?: number | null;
	numDukptKeys?: number | null;
	numMasterKeys?: number | null;
	os?: string | null;
	pciFirmwareVersion?: string | null;
	pedCurrentTemp?: number | null;
	pedModel?: string | null;
	pedStatus?: number | null;
	pedVersion?: string | null;
	ramAvail?: string | null;
	ramTotal?: string | null;
	secureCpuId?: string | null;
	securityVersion?: string | null;
	serial?: string | null;
	simBandwidth?: number | null;
	simCellDetails?: string | null;
	simCountry?: string | null;
	simDns1Address?: string | null;
	simDns2Address?: string | null;
	simGatewayAddress?: string | null;
	simIpAddress?: string | null;
	simNetwork?: string | null;
	simNetworkName?: string | null;
	simNetworkType?: string | null;
	simOperator?: string | null;
	simOperatorName?: string | null;
	simRssi?: number | null;
	simSerialNumber?: string | null;
	simState?: number | null;
	simSubscriberId?: string | null;
	softwareVersion?: string | null;
	tcpDhcp?: boolean | null;
	tcpDns1Address?: string | null;
	tcpDns2Address?: string | null;
	tcpGatewayAddress?: string | null;
	tcpIpAddress?: string | null;
	tcpMac?: string | null;
	tcpMaxTransferSpeeds?: string | null;
	tcpTransferSpeeds?: string | null;
	timestamp: AWSDateTime;
	timestampUtc: AWSDateTime;
	uiSoftwareVersion?: string | null;
	widthPixels?: string | null;
	wifiAvailableNetworks?: string | null;
	wifiBssid?: string | null;
	wifiChannel?: number | null;
	wifiDns1Address?: string | null;
	wifiDns2Address?: string | null;
	wifiFrequency?: string | null;
	wifiGatewayAddress?: string | null;
	wifiIpAddress?: string | null;
	wifiMacAddress?: string | null;
	wifiMaxTransferSpeed?: number | null;
	wifiRssi?: number | null;
	wifiSecurityModel?: string | null;
	wifiSpeed?: number | null;
	wifiSsid?: string | null;
	wifiStandard?: string | null;
	wifiState?: number | null;
	wifiTransferSpeed?: number | null;
	xdpi?: string | null;
	ydpi?: string | null;
};

export type DeviceUnpairInput = {
	deviceUuid: string;
};

export type DeviceUuidInput = {
	model: string;
	serial: string;
};

export type EcommerceTransactionRecordInput = {
	status: EcommerceTransactionStatus;
	transactionUuid: string;
	updatedAt: AWSDateTime;
};

export type ImposConfigurationInput = {
	clientApiKey?: string | null;
	hostIp?: string | null;
	venues?: Readonly<Array<PosVenueInput>> | null;
};

export type IntFilterInput = {
	between?: Readonly<Array<number | null>> | null;
	contains?: number | null;
	eq?: number | null;
	ge?: number | null;
	gt?: number | null;
	le?: number | null;
	lt?: number | null;
	ne?: number | null;
	notContains?: number | null;
};

export type ListFilterInput = {
	in: Readonly<Array<string>>;
};

export type PairedDevicesFilter = {
	deviceUuid?: string | null;
	provider?: ConnectionType | null;
};

export type PayByContactInput = {
	contactDetails: string;
	contactMethod: ContactMethod;
};

export type PosLocationInput = {
	id: string;
	name: string;
	number?: string | null;
};

export type PosVenueInput = {
	id?: string | null;
	locations?: Readonly<Array<PosLocationInput>> | null;
	name: string;
};

export type SendPayByLinkInput = {
	contact: PayByContactInput;
	id: string;
};

export type SiteFilterInput = {
	siteName?: StringFilterInput | null;
};

export type SiteNextTokenInput = {
	siteNameSortKey: string;
	type: string;
};

export type StringEqualInput = {
	eq: string;
};

export type StringFilterInput = {
	beginsWith?: string | null;
	between?: Readonly<Array<string | null>> | null;
	contains?: string | null;
	eq?: string | null;
	ge?: string | null;
	gt?: string | null;
	in?: Readonly<Array<string | null>> | null;
	le?: string | null;
	lt?: string | null;
	ne?: string | null;
	notContains?: string | null;
};

export type SubscriptionEcommerceRecordInput = {
	amount?: number | null;
	amountDue?: number | null;
	contactDetails?: string | null;
	contactError?: string | null;
	contactStatus?: EcommerceContactStatus | null;
	contactType?: ContactMethod | null;
	contactUuid?: string | null;
	createdTimestamp?: AWSDateTime | null;
	currency?: string | null;
	customerUuid?: string | null;
	entityUuid: string;
	expiry?: AWSDateTime | null;
	id: string;
	lastViewedAt?: AWSDateTime | null;
	originalContactName?: string | null;
	paidAmount?: number | null;
	paymentLink?: string | null;
	reference: string;
	siteName: string;
	siteUuid: string;
	status: EcommerceStatus;
	surcharge?: number | null;
	taxAmounts?: Readonly<Array<TaxAmountInput | null>> | null;
	timestamp: AWSDateTime;
	timestampSent?: AWSDateTime | null;
	transactionRecords?: Readonly<
		Array<EcommerceTransactionRecordInput | null>
	> | null;
	transactionUuid?: string | null;
	type: EcommerceType;
};

export type TaxAmountInput = {
	amount: number;
	name: string;
};

export type TransactionFilterInput = {
	amount?: IntFilterInput | null;
	channel?: StringFilterInput | null;
	contactUuid?: ListFilterInput | null;
	depositShortId?: StringEqualInput | null;
	depositUuid?: StringFilterInput | null;
	deviceUuid?: StringFilterInput | null;
	externalReference?: StringEqualInput | null;
	maskedPan?: StringFilterInput | null;
	or?: Readonly<Array<TransactionFilterInput | null>> | null;
	panToken?: StringFilterInput | null;
	par?: StringFilterInput | null;
	posName?: StringFilterInput | null;
	reference?: StringFilterInput | null;
	refunded?: BoolFilterInput | null;
	responseCode?: StringFilterInput | null;
	reversed?: BoolFilterInput | null;
	review?: BoolFilterInput | null;
	scheme?: StringFilterInput | null;
	siteUuid?: StringFilterInput | null;
	source?: StringFilterInput | null;
	sourceFilter?: ListFilterInput | null;
	splitPaymentUuid?: StringFilterInput | null;
	status?: StringFilterInput | null;
	timestamp?: StringFilterInput | null;
	type?: StringFilterInput | null;
	wasOfflineApproved?: StringFilterInput | null;
};

export type TransactionNextTokenInput = {
	entityUuid: string;
	id: string;
	type: string;
};

export type AWSDate = string;

export type AWSTime = string;

export type AWSDateTime = string;

export type AWSTimestamp = string;

export type AWSEmail = string;

export type AWSJSON = string;

export type AWSURL = string;

export type AWSPhone = string;

export type AWSIPAddress = string;

export type BigInt = string;

export type Double = string;

const $Root = {
	query: Query,
	mutation: Mutation,
	subscription: Subscription,
};

namespace $RootTypes {
	export type query = Query;
	export type mutation = Mutation;
	export type subscription = Subscription;
}

export function query<Sel extends Selection<$RootTypes.query>>(
	name: string,
	selectFn: (q: $RootTypes.query) => [...Sel],
): TypedDocumentNode<GetOutput<Sel>, GetVariables<Sel>>;
export function query<Sel extends Selection<$RootTypes.query>>(
	selectFn: (q: $RootTypes.query) => [...Sel],
): TypedDocumentNode<GetOutput<Sel>, Simplify<GetVariables<Sel>>>;
export function query<Sel extends Selection<$RootTypes.query>>(
	name: any,
	selectFn?: any,
) {
	if (!selectFn) {
		selectFn = name;
		name = "";
	}
	let field = new $Field<"query", GetOutput<Sel>, GetVariables<Sel>>("query", {
		selection: selectFn(new $Root.query()),
	});
	const str = fieldToQuery(`query ${name}`, field);

	return gql(str) as any;
}

export function mutation<Sel extends Selection<$RootTypes.mutation>>(
	name: string,
	selectFn: (q: $RootTypes.mutation) => [...Sel],
): TypedDocumentNode<GetOutput<Sel>, GetVariables<Sel>>;
export function mutation<Sel extends Selection<$RootTypes.mutation>>(
	selectFn: (q: $RootTypes.mutation) => [...Sel],
): TypedDocumentNode<GetOutput<Sel>, Simplify<GetVariables<Sel>>>;
export function mutation<Sel extends Selection<$RootTypes.query>>(
	name: any,
	selectFn?: any,
) {
	if (!selectFn) {
		selectFn = name;
		name = "";
	}
	let field = new $Field<"mutation", GetOutput<Sel>, GetVariables<Sel>>(
		"mutation",
		{
			selection: selectFn(new $Root.mutation()),
		},
	);
	const str = fieldToQuery(`mutation ${name}`, field);

	return gql(str) as any;
}

export function subscription<Sel extends Selection<$RootTypes.subscription>>(
	name: string,
	selectFn: (q: $RootTypes.subscription) => [...Sel],
): TypedDocumentNode<GetOutput<Sel>, GetVariables<Sel>>;
export function subscription<Sel extends Selection<$RootTypes.subscription>>(
	selectFn: (q: $RootTypes.subscription) => [...Sel],
): TypedDocumentNode<GetOutput<Sel>, Simplify<GetVariables<Sel>>>;
export function subscription<Sel extends Selection<$RootTypes.query>>(
	name: any,
	selectFn?: any,
) {
	if (!selectFn) {
		selectFn = name;
		name = "";
	}
	let field = new $Field<"subscription", GetOutput<Sel>, GetVariables<Sel>>(
		"subscription",
		{
			selection: selectFn(new $Root.subscription()),
		},
	);
	const str = fieldToQuery(`subscription ${name}`, field);

	return gql(str) as any;
}

const $InputTypes: { [key: string]: { [key: string]: string } } = {
	BoolFilterInput: {
		eq: "Boolean",
		ne: "Boolean",
	},
	CreateAndSendPayByLinkInput: {
		amount: "Int!",
		contact: "PayByContactInput!",
		reference: "String!",
	},
	DevicePairInput: {
		override: "Boolean!",
		pairedDeviceUuid: "ID!",
	},
	DeviceStatusInput: {
		androidBuild: "String",
		androidDevice: "String",
		androidKernel: "String",
		androidModel: "String",
		androidOs: "String",
		appUptimeInSeconds: "Int",
		batteryLevelPercent: "Int",
		connectionType: "Int",
		customerId: "String",
		customerName: "String",
		density: "String",
		densityDpi: "String",
		deviceUptimeInSeconds: "Int",
		emvL1Version: "String",
		emvL2Version: "String",
		firmwareVersion: "String",
		flashAvail: "String",
		flashTotal: "String",
		hardwareVersion: "String",
		heightPixels: "String",
		id: "ID!",
		kernel: "String",
		ksn: "String",
		model: "String",
		numAids: "Int",
		numCapk: "Int",
		numDukptKeys: "Int",
		numMasterKeys: "Int",
		os: "String",
		pciFirmwareVersion: "String",
		pedCurrentTemp: "Int",
		pedModel: "String",
		pedStatus: "Int",
		pedVersion: "String",
		ramAvail: "String",
		ramTotal: "String",
		secureCpuId: "String",
		securityVersion: "String",
		serial: "String",
		simBandwidth: "Int",
		simCellDetails: "String",
		simCountry: "String",
		simDns1Address: "String",
		simDns2Address: "String",
		simGatewayAddress: "String",
		simIpAddress: "String",
		simNetwork: "String",
		simNetworkName: "String",
		simNetworkType: "String",
		simOperator: "String",
		simOperatorName: "String",
		simRssi: "Int",
		simSerialNumber: "String",
		simState: "Int",
		simSubscriberId: "String",
		softwareVersion: "String",
		tcpDhcp: "Boolean",
		tcpDns1Address: "String",
		tcpDns2Address: "String",
		tcpGatewayAddress: "String",
		tcpIpAddress: "String",
		tcpMac: "String",
		tcpMaxTransferSpeeds: "String",
		tcpTransferSpeeds: "String",
		timestamp: "AWSDateTime!",
		timestampUtc: "AWSDateTime!",
		uiSoftwareVersion: "String",
		widthPixels: "String",
		wifiAvailableNetworks: "String",
		wifiBssid: "String",
		wifiChannel: "Int",
		wifiDns1Address: "String",
		wifiDns2Address: "String",
		wifiFrequency: "String",
		wifiGatewayAddress: "String",
		wifiIpAddress: "String",
		wifiMacAddress: "String",
		wifiMaxTransferSpeed: "Int",
		wifiRssi: "Int",
		wifiSecurityModel: "String",
		wifiSpeed: "Int",
		wifiSsid: "String",
		wifiStandard: "String",
		wifiState: "Int",
		wifiTransferSpeed: "Int",
		xdpi: "String",
		ydpi: "String",
	},
	DeviceUnpairInput: {
		deviceUuid: "ID!",
	},
	DeviceUuidInput: {
		model: "String!",
		serial: "String!",
	},
	EcommerceTransactionRecordInput: {
		status: "EcommerceTransactionStatus!",
		transactionUuid: "ID!",
		updatedAt: "AWSDateTime!",
	},
	ImposConfigurationInput: {
		clientApiKey: "String",
		hostIp: "String",
		venues: "[PosVenueInput!]",
	},
	IntFilterInput: {
		between: "[Int]",
		contains: "Int",
		eq: "Int",
		ge: "Int",
		gt: "Int",
		le: "Int",
		lt: "Int",
		ne: "Int",
		notContains: "Int",
	},
	ListFilterInput: {
		in: "[String!]!",
	},
	PairedDevicesFilter: {
		deviceUuid: "ID",
		provider: "ConnectionType",
	},
	PayByContactInput: {
		contactDetails: "String!",
		contactMethod: "ContactMethod!",
	},
	PosLocationInput: {
		id: "String!",
		name: "String!",
		number: "String",
	},
	PosVenueInput: {
		id: "String",
		locations: "[PosLocationInput!]",
		name: "String!",
	},
	SendPayByLinkInput: {
		contact: "PayByContactInput!",
		id: "ID!",
	},
	SiteFilterInput: {
		siteName: "StringFilterInput",
	},
	SiteNextTokenInput: {
		siteNameSortKey: "String!",
		type: "String!",
	},
	StringEqualInput: {
		eq: "String!",
	},
	StringFilterInput: {
		beginsWith: "String",
		between: "[String]",
		contains: "String",
		eq: "String",
		ge: "String",
		gt: "String",
		in: "[String]",
		le: "String",
		lt: "String",
		ne: "String",
		notContains: "String",
	},
	SubscriptionEcommerceRecordInput: {
		amount: "Int",
		amountDue: "Int",
		contactDetails: "String",
		contactError: "String",
		contactStatus: "EcommerceContactStatus",
		contactType: "ContactMethod",
		contactUuid: "String",
		createdTimestamp: "AWSDateTime",
		currency: "String",
		customerUuid: "String",
		entityUuid: "String!",
		expiry: "AWSDateTime",
		id: "ID!",
		lastViewedAt: "AWSDateTime",
		originalContactName: "String",
		paidAmount: "Int",
		paymentLink: "String",
		reference: "String!",
		siteName: "String!",
		siteUuid: "String!",
		status: "EcommerceStatus!",
		surcharge: "Int",
		taxAmounts: "[TaxAmountInput]",
		timestamp: "AWSDateTime!",
		timestampSent: "AWSDateTime",
		transactionRecords: "[EcommerceTransactionRecordInput]",
		transactionUuid: "ID",
		type: "EcommerceType!",
	},
	TaxAmountInput: {
		amount: "Int!",
		name: "String!",
	},
	TransactionFilterInput: {
		amount: "IntFilterInput",
		channel: "StringFilterInput",
		contactUuid: "ListFilterInput",
		depositShortId: "StringEqualInput",
		depositUuid: "StringFilterInput",
		deviceUuid: "StringFilterInput",
		externalReference: "StringEqualInput",
		maskedPan: "StringFilterInput",
		or: "[TransactionFilterInput]",
		panToken: "StringFilterInput",
		par: "StringFilterInput",
		posName: "StringFilterInput",
		reference: "StringFilterInput",
		refunded: "BoolFilterInput",
		responseCode: "StringFilterInput",
		reversed: "BoolFilterInput",
		review: "BoolFilterInput",
		scheme: "StringFilterInput",
		siteUuid: "StringFilterInput",
		source: "StringFilterInput",
		sourceFilter: "ListFilterInput",
		splitPaymentUuid: "StringFilterInput",
		status: "StringFilterInput",
		timestamp: "StringFilterInput",
		type: "StringFilterInput",
		wasOfflineApproved: "StringFilterInput",
	},
	TransactionNextTokenInput: {
		entityUuid: "String!",
		id: "String!",
		type: "String!",
	},
};
